import RemoteConfigurationPage from './RemoteConfigurationPage';

export default RemoteConfigurationPage;
